<div class="container-fluid">
	<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
		<dropdown-district class="noprint"></dropdown-district>
		<dropdown-area class="noprint"></dropdown-area>
		<dropdown-school class="noprint"></dropdown-school>
	</div>

	<!-- <app-phase-select class="noprint" style="margin-top: 10px"></app-phase-select> -->
	<div class="btn -primary d-block   noprint bg-white" style="margin: 2px 4px " (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
		<i *ngIf="isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
		<i *ngIf="!isCollapsed" class="fa fa-caret-up" aria-hidden="true"></i>
		{{ isCollapsed ? 'Show Filters' : 'Hide Filters' }}
	</div>
	<div class="card h-100">

		<my-tabs>
			<my-tab tabTitle="Admin">
				<my-tabs>
					<!-- Start of Inner Tabs-->

					<my-tab tabTitle="Admin Charts" active="true">
						<div class="tw-flex tw-flex-row tw-gap-2 md:tw-gap-4 tw-relative">
							<div class="tw-min-w-[200px] print:tw-hidden tw-relative tw-z-10">
								<app-tree-filter [nodes]="nodes" [selectedSchoolId]="selectedSchool?.id"
									(node)="nodeChange($event)"></app-tree-filter>
							</div>
							<div class="tw-flex-1 tw-h-full tw-relative tw-z-10">
								<app-raw-balloon [node]="selectedNode"></app-raw-balloon>
							</div>
						</div>
					</my-tab>

					<my-tab tabTitle="Edit Questions and Phases" *hasPermission="'Admin'">
						<div class="row">
							<div class="col-sm">
								<div class="h-100">
									<app-edit-questions></app-edit-questions>
								</div>
							</div>
						</div>
					</my-tab>
					<!-- <my-tab tabTitle="Documents" *hasPermission="'Admin'">
						<app-manage-documents></app-manage-documents>
					</my-tab> -->
				</my-tabs>
			</my-tab>
			<!-- End of Inner Tabs-->

			<my-tab tabTitle="Growth Chart">
				<div class="tw-flex tw-flex-row tw-gap-2 md:tw-gap-4 tw-relative">
					<div class="tw-min-w-[200px] print:tw-hidden tw-relative tw-z-10">
						<app-tree-filter [nodes]="nodes"  [selectedSchoolId]="selectedSchool?.id"
							(node)="nodeChange($event)"></app-tree-filter>
					</div>
					<div class="tw-flex-1 tw-h-full tw-relative tw-z-10">
						<app-reading-achievement-phases [node]="selectedNode" class="reading-achievement"></app-reading-achievement-phases>
					</div>
				</div>
			</my-tab>

			<my-tab [tabTitle]="'School'">
				<h3 class="print">
					Phonics Advantage Reading Assessment<br />
					{{ selectedSchool?.name }}
				</h3>
				<div class="row">
					<div class="col">
						<div class="h-100">
							<app-assessments-bar></app-assessments-bar>
							<app-number-of-students-per-challenge [node]="selectedSchool" [classrooms]='classrooms'></app-number-of-students-per-challenge>
						</div>
					</div>
				</div>
			</my-tab>
			<my-tab tabTitle="Classroom">
				<div class="row mb-5">
					<div class="col">
						<dropdown-classroom class="noprint"></dropdown-classroom>

						<app-progress-table-accordion></app-progress-table-accordion>

					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="h-100">
							<app-number-of-students-per-challenge [node]="selectedClassroom" ></app-number-of-students-per-challenge>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="h-100 noprint">
							<export-data-card [node]="this.selectedSchool"></export-data-card>
						</div>
					</div>
				</div>
			</my-tab>
		</my-tabs>
	</div>
</div>

